
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/it.js"
  import data from "/opt/build/repo/.cache/json/layout-it.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/it.js